(() => {
  const reservedReservationHistory = '.reserved-reservation-history';
  const eventReservationHistory = '.event-reservation-history';
  const barbecueReservationHistory = '.barbecue-reservation-history';
  const campingReservationHistory = '.camping-reservation-history';
  const reservationHistoryPath = process.env.JS_BASE_URL + 'customer/mypage/reservation_histories';
  const init = () => {
    if (location.pathname === reservationHistoryPath) {
      $('.reserved-reservation-history').addClass('active');
      $('.not_reserved_event_reservations').hide();
      $('.not_reserved_barbecue_reservations').hide();
      $('.not_reserved_camping_reservations').hide();
    }
    $('body')
      .on('click', reservedReservationHistory, categorizeReservedReservation)
      .on('click', eventReservationHistory, categorizeOnlyEventReservation)
      .on('click', barbecueReservationHistory, categorizeOnlyBarbecueReservation)
      .on('click', campingReservationHistory, categorizeOnlyCampingReservation);
  }

  const categorizeReservedReservation = e => {
    const $element = $(e.currentTarget);
    $('.reservation-active-flag').not($element).removeClass('active');
    $element.addClass('active');

    $('.reserved_event_reservations').show();
    $('.reserved_barbecue_reservations').show();
    $('.reserved_camping_reservations').show();

    $('.not_reserved_event_reservations').hide();
    $('.not_reserved_barbecue_reservations').hide();
    $('.not_reserved_camping_reservations').hide();
  }

  const categorizeOnlyEventReservation = e => {
    const $element = $(e.currentTarget);
    $('.reservation-active-flag').not($element).removeClass('active');
    $element.addClass('active');

    $('.reserved_event_reservations').show();
    $('.reserved_barbecue_reservations').hide();
    $('.reserved_camping_reservations').hide();

    $('.not_reserved_event_reservations').show();
    $('.not_reserved_barbecue_reservations').hide();
    $('.not_reserved_camping_reservations').hide();
  }

  const categorizeOnlyBarbecueReservation = e => {
    const $element = $(e.currentTarget);
    $('.reservation-active-flag').not($element).removeClass('active');
    $element.addClass('active');

    $('.reserved_event_reservations').hide();
    $('.reserved_barbecue_reservations').show();
    $('.reserved_camping_reservations').hide();

    $('.not_reserved_event_reservations').hide();
    $('.not_reserved_barbecue_reservations').show();
    $('.not_reserved_camping_reservations').hide();
  }

  const categorizeOnlyCampingReservation = e => {
    const $element = $(e.currentTarget);
    $('.reservation-active-flag').not($element).removeClass('active');
    $element.addClass('active');

    $('.reserved_event_reservations').hide();
    $('.reserved_barbecue_reservations').hide();
    $('.reserved_camping_reservations').show();

    $('.not_reserved_event_reservations').hide();
    $('.not_reserved_barbecue_reservations').hide();
    $('.not_reserved_camping_reservations').show();
  }

  $(init);
})();

